"use client";

import { useMemo } from "react";
import { useSelector } from "react-redux";

import { useSDK } from "@/@sdk/sdk.hooks";
import { selectIntegrationConfig_QuickBooks } from "@/store/modules/workspace/workspace.selectors";
import type { QuickBooksAccountOption } from "@/components/integrations/quickbooks-account-selector";

function isQuickBooksConnected(integrationConfig: unknown): boolean {
  const config = integrationConfig as { isReady?: boolean; config?: { realmId?: string } };
  return Boolean(config?.isReady && config?.config?.realmId);
}

export function useQuickBooksAccounts(enabled = true) {
  const integrationConfig = useSelector(selectIntegrationConfig_QuickBooks);
  const connected = useMemo(
    () => isQuickBooksConnected(integrationConfig),
    [integrationConfig]
  );

  const {
    data: accountsRes,
    isLoading,
    error,
    reload,
  } = useSDK(
    (SDK) => SDK.quickbooks.getAccounts(),
    [connected, (integrationConfig as { config?: { realmId?: string } })?.config?.realmId],
    !enabled || !connected
  );

  const accounts = ((accountsRes as { accounts?: QuickBooksAccountOption[] })?.accounts ??
    []) as QuickBooksAccountOption[];

  return {
    connected,
    accounts,
    isLoading,
    error,
    reload,
  };
}
